
//navbar scroll
stickyNav();
$(window).scroll(function () {
  stickyNav();
});

function stickyNav() {
  var nav = $(".navbar").not(".mobile");
  var navHeight = nav.height();
  
  nav.css('top', '0px');
  
  if ($(window).scrollTop() > navHeight) {
    nav.removeClass('navbar-expanded');
  } else {
    nav.addClass('navbar-expanded');
  }
}


//user image upload
var element = document.getElementById("user_picture_attributes_photo") || document.getElementById("user_picture_attributes_photo_v2");
if (element) {
  element.onchange = function () {
    var uploadFile = document.getElementById("uploadFile");
    if (uploadFile) {
      uploadFile.value = this.files[0].name;
    }
    
    // Preview image
    if (this.files && this.files[0]) {
      var reader = new FileReader();
      reader.onload = function (e) {
        var avatar = document.getElementById("avatar");
        if (avatar) {
          avatar.style.backgroundImage = 'url(' + e.target.result + ')';
        }
      };
      reader.readAsDataURL(this.files[0]);
    }
  };
}


//faq scroll fix (temp)
$('.faq-panel-group .panel-heading .panel-title a').click(function (e) {
  e.preventDefault();
});


//Language selection
$.fn.dropdown = function () {
  var widget = $(this);
  var label = widget.find('span.valueOfButton');
  var list = widget.children('ul');
  var selected;
  var highlighted;
  
  var select = function (i) {
    selected = $(i);
    label.html(selected.html());
  };
  
  select($('.language-select .default a'));
  
  var highlight = function (i) {
    highlighted = $(i);
    highlighted
      .addClass('selected')
      .siblings('.selected')
      .removeClass('selected');
  };
  
  var scroll = function (event) {
    list.scrollTo('.selected');
  };
  
  var hover = function (event) {
    highlight(this);
  };
  
  var rebind = function (event) {
    bind();
  };
  
  var bind = function () {
    list.on('mouseover', 'li', hover);
    widget.off('mousemove', rebind);
  };
  
  var unbind = function () {
    list.off('mouseover', 'li', hover);
    widget.on('mousemove', rebind);
  };
  
  list.on('click', 'li a', function (event) {
    select(this);
  });
  
  widget.keydown(function (event) {
    unbind();
    switch (event.keyCode) {
      case 38:
        highlight((highlighted && highlighted.prev().length > 0) ? highlighted.prev() : list.children().last());
        scroll();
        break;
      case 40:
        highlight((highlighted && highlighted.next().length > 0) ? highlighted.next() : list.children().first());
        scroll();
        break;
      case 13:
        if (highlighted) {
          select(highlighted);
        }
        break;
    }
  });
  bind();
};

$.fn.scrollTo = function (target, options, callback) {
  if (typeof options === 'function' && arguments.length === 2) {
    callback = options;
    options = target;
  }
  
  var settings = $.extend({
    scrollTarget: target,
    offsetTop: 185,
    duration: 0,
    easing: 'linear'
  }, options);
  
  return this.each(function (i) {
    var scrollPane = $(this);
    var scrollTarget = (typeof settings.scrollTarget === 'number') ? settings.scrollTarget : $(settings.scrollTarget);
    var scrollY = (typeof scrollTarget === 'number') ? scrollTarget : scrollTarget.offset().top + scrollPane.scrollTop() - parseInt(settings.offsetTop, 10);
    
    scrollPane.animate({scrollTop: scrollY}, parseInt(settings.duration, 10), settings.easing, function () {
      if (typeof callback === 'function') {
        callback.call(this);
      }
    });
  });
};

$('div.btn-group').css('opacity', 1).dropdown();


//Masonry js functions

import $ from 'jquery';
import imagesLoaded from 'imagesloaded';
import Masonry from 'masonry-layout';

imagesLoaded.makeJQueryPlugin($);

$(function() {
  var $container = $('.grid-boxes');
  if ($container.length > 0) {
    $container.imagesLoaded(function() {
      $container.each(function() {
        // (opzionale: calcola la larghezza dei box prima!)
        new Masonry(this, {
          itemSelector: '.grid-boxes-in',
          gutter: 30,
          // columnWidth: 300,
        });
      });
    });
    $(window).resize(function() {
      // (Re-instanzia Masonry se necessario, oppure aggiorna layout)
      $container.each(function() {
        if (this.masonry) this.masonry.layout();
      });
    });
  }
});
